import React, {lazy, Suspense} from 'react';
import {RouteObject} from 'react-router';
import routes from './routes';
import SuspenseLoader from './components/SuspenseLoader';
import DashboardLayout from './layouts/dashboardLayout';
import BaseLayout from './layouts/baseLayout';
import VisitorLayout from './layouts/visitorLayout';
import SignupSuccess from "./scenes/unauthenticated/views/signupSuccess";

const Loader = (Component: React.ComponentType) => (props: any) =>
    (
        <Suspense fallback={<SuspenseLoader />}>
            <Component {...props} />
        </Suspense>
    );

const Explore = Loader(lazy(() => import('./scenes/unauthenticated/views/explore')));
const ExploreResult = Loader(lazy(() => import('./scenes/unauthenticated/views/result')));
const VisitorView = Loader(lazy(() => import('./scenes/unauthenticated/views/visit')));
const Login = Loader(lazy(() => import('./scenes/unauthenticated/views/login')));
const Signup = Loader(lazy(() => import('./scenes/unauthenticated/views/signup')));
const ConfirmResetPassword = Loader(lazy(() => import('./scenes/unauthenticated/views/confirmResetPassword')));
const Reset = Loader(lazy(() => import('./scenes/unauthenticated/views/reset')));

const Dashboard = Loader(lazy(() => import('./scenes/authenticated/dashboard')));
const Projects = Loader(lazy(() => import('./scenes/authenticated/projects/projectsTable')));
const ViewProject = Loader(lazy(() => import('./scenes/authenticated/projects/viewProject')));
const CreateProject = Loader(lazy(() => import('./scenes/authenticated/projects/createProject/createProject')));

const Status404 = Loader(lazy(() => import('./components/Status404')));

const router = (): RouteObject[] => [
    {
        path: '/',
        element: <BaseLayout />,
        children: [
            { path: routes.ROOT, element: <Login /> },
            { path: routes.EXPLORE, element: <Explore />},
            { path: routes.RESULT, element: <ExploreResult />},
            { path: routes.LOGIN, element: <Login /> },
            { path: routes.REGISTER, element: <Signup /> },
            { path: routes.RESET, element: <Reset /> },
            { path: routes.CONFIRM_RESET, element: <ConfirmResetPassword /> },
            { path: routes.SIGNUP_SUCCESS, element: <SignupSuccess /> },
            { path: '*', element: <Status404 /> },
        ],
    },
    {
        path: '/app',
        element: <DashboardLayout />,
        children: [
            { path: routes.APP.ROOT, element: <Dashboard /> },
            { path: routes.APP.DASHBOARD, element: <Dashboard /> },
            { path: routes.APP.PROJECTS.CREATE_PROJECT, element: <CreateProject /> },
            { path: routes.APP.PROJECTS.PROJECT, element: <ViewProject /> },
            { path: routes.APP.PROJECTS.ROOT, element: <Projects /> },
            { path: '*', element: <Status404 /> },
        ],
    },
    {
        path: '/visit',
        element: <VisitorLayout />,
        children: [
            { path: routes.VISIT.ROOT, element: <VisitorView />},
            { path: '*', element: <Status404 /> },
        ],
    },
];

export default router;
